<template>
    <div class="page bg-gray page-flex">
        <appStatus :statusHeight="statusHeight"></appStatus>
        <div class="page-input-title" :style="{top:statusHeight+'rem'}">
            <div class="alifont icon-back left-icon click" @click="back"></div>
            <div class="center-box flex click" @click="$refs.houseQuarterList.popupShow = true">
                {{orgName|| '全部小区'}}
                <div class="alifont icon-lujingbeifen"></div>
            </div>
            <div class="right alifont icon-xpsousuo color-333 click" @click="$router.push({name:'lockerOrderSearch'})"></div>
        </div>

        <van-tabs v-model="tabItemActive" swipeable :swipe-threshold="5" :line-width="'.6rem'" @click="tabClick">
            <van-tab :title="item.title" :name="item.name" v-for="(item,$index) in tabList" :key="$index"></van-tab>
        </van-tabs>

        <div class="flex1 posi-rel pd-025 pb-25">

            <scroller ref="scroller" :on-refresh="loadNewData" :on-infinite="loadMore">
                <div class="card mt-20 pd-025 pt-25" v-for="(item,$index) in data" :key="$index">
                    <div class="flex-between fs-28 font-bold">
                        <div class="color-333">收货人：{{item.userName}}  <span class="ml-10">{{item.userMobile}}</span></div>
                        <div :class="item.orderStatus == 1?'color-333': item.orderStatus == 2? 'color-org': item.orderStatus == 3?'color-main':''">{{stutas[item.orderStatus]}}</div>
                    </div>
                    <div class="color-999 fs-24 mt-8">订单号：{{item.orderNo}}</div>
                    <div class="product-list">
                        <div class="product-item" v-for="(prod,$prodIndex) in item.productList">
                            <img :src="prod.imgPathView" alt="">
                            <div class="tips" v-if="prod.productQty >1">{{prod.productQty}}件</div>
                        </div>
                    </div>
                    <div class="mt-25 bd-top pd-250 flex-center" v-if="item.orderStatus == 2">
                        <div class="item-label">配送小区</div>
                        <div class="ml-10 fs-28 color-333 flex1">{{item.orgName}}</div>
                    </div>
                    <div class="mt-25 bd-top pd-250 flex-center" v-if="item.orderStatus == 3 || item.orderStatus == 1">
                        <div class="item-label">寄存柜</div>
                        <div class="ml-10 fs-28 color-333 flex1">{{item.orderShopName}}</div>
                        <div class="color-org fs-28">货道 {{item.wayCode}}</div>
                    </div>
                    <div class="bd-top pd-250 flex-between fs-28 color-333" v-if="item.orderStatus == 3 || item.orderStatus == 1">
                        <div>补货人：{{item.linkName}}</div>
                        <div>{{item.operateTime}}</div>
                    </div>
                </div>
            </scroller>
        </div>
        <houseQuarterList ref="houseQuarterList" @sure="quarterConfirm"></houseQuarterList>
    </div>
</template>

<script>
    import initData from "@/mixins/initData"
    import routerBack from "@/mixins/routerBack"
    import appStatus from "@/components/appStatus/index"
    import getAppStatusHeight from "@/mixins/getAppStatusHeight";
    import houseQuarterList from "./houseQuarterList";
    export default {
        name: "lockerOrderList",
        mixins: [initData, routerBack, getAppStatusHeight],
        components: {appStatus,houseQuarterList},
        data(){
            return{
                tabItemActive: 0,
                tabList:[
                    {title:'全部',name: 0},
                    {title:'待配送',name:2},
                    {title:'待取货',name:3},
                    {title:'已完成',name:1},
                ],
                stutas:{
                    1:'已完成',
                    2:'待配送',
                    3:'待取货',
                },
                orgId:null,
                orgName:'',
            }
        },
        created() {
            this.orgId = this.$route.query.orgId;
            this.orgName = this.$route.query.orgName;
        },
        methods:{
            back() {
                if (this.isBackClose) {
                    try {
                        window.native.onFinish();
                    } catch (e) {

                    }
                } else {
                    try {
                        window.native.onBack();
                    } catch (e) {
                        this.$router.go(-1)
                    }
                }
            },

            beforeInit() {
                this.params = { page : this.page, limit: this.limit,orgId:this.orgId};
                this.url = 'order/orderBase/qryOrgWayOrderList';
                let query = this.pageInfo;
                for (var key in query) {
                    if (query[key]) {
                        this.params[key] = query[key]
                    }
                }
                return true
            },

            tabClick(name){
                let _this = this;
                if(name == 0){
                    this.pageInfo = {}
                }else{
                    this.pageInfo = {
                        orderStatus : name
                    }
                }
                _this.handleQuery();
            },
            quarterConfirm(data){
                this.orgId = data.orgId;
                this.orgName = data.orgName;
                this.handleQuery();
            },
        }
    }
</script>

<style scoped lang="scss">
    .icon-xpsousuo{
        font-size: .48rem;
    }
    .icon-lujingbeifen{
        font-size: .22rem;
        color: #999;
    }
    .product-list{
        display: flex;
        flex-wrap: wrap;
        padding-top: .13rem;
        .product-item{
            position: relative;
            width: 1.2rem;
            height: 1.2rem;
            margin-top: .12rem;
            margin-right: .12rem;
            &:nth-child(5n){
                margin-right: 0;
            }
            .tips{
                position: absolute;
                bottom: 0;
                left: 0;
                width: 100%;
                height: .32rem;
                text-align: center;
                line-height: .32rem;
                background: rgba(0,0,0,.6);
                color: #fff;
                font-size: .22rem;
            }
        }
    }
    .item-label{
        line-height: .36rem;
        height: .36rem;
        border-radius: .08rem;
        background: $main-color;
        padding: 0 .1rem;
        font-size: .26rem;
        color: #fff;
    }
</style>



// WEBPACK FOOTER //
// lockerOrderList.vue?4eae5e20